/**
 * App.tsx
 * 
 * MediaSFU Meeting - Standalone AI-Powered Video Conferencing
 * 
 * This is a standalone meeting interface powered by MediaSFU
 * with modern glassmorphic design and AI agent capabilities.
 */

import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import MeetingInterface from './MeetingInterface';
import './App.css';

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <MeetingInterface />
    </HelmetProvider>
  );
};

export default App;
